import { render } from "./Home.vue?vue&type=template&id=1cd068b4&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=1cd068b4&lang=scss&scoped=true"

import exportComponent from "/home/forge/s.thebuyhive.com/expertsourcing/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cd068b4"]])

export default __exports__